angular.module('lf.desktop')

.directive('miniCartItemActionsDropdownTrigger', function () {
  return function (scope, el, attrs) {
    var selectors = '.mini-cart__item-action-remove-btn, .mini-cart__item-actions-dropdown';
    var $parent = el.closest('.mini-cart__item-actions');
    var $actionsDropdown = $parent.find('.mini-cart__item-actions-dropdown');
    var hideDelayId = null;
    
    $parent
      .on('mouseenter.mini-cart-item-actions-dropdown', selectors, function () {
        clearHideDelayTimeout();
        if ($actionsDropdown.is(':visible')) return;
        el.addClass('mini-cart__item-action-remove-btn--hover');
        $actionsDropdown.velocity({opacity: 1}, {duration: 200, display: 'block'});
      })
      .on('mouseleave.mini-cart-item-actions-dropdown', selectors, function () {
        hideDelayId = setTimeout(hide, 300);
      });
    
    function hide () {
      $actionsDropdown.velocity({opacity: 0}, {duration: 200, display: 'none'});
      el.removeClass('mini-cart__item-action-remove-btn--hover');
    }
    
    function clearHideDelayTimeout () {
      clearTimeout(hideDelayId);
    }
    
    scope.$on('$destroy', function () {
      $parent.off('.mini-cart-item-actions-dropdown');
    });
    
  }
});
